<template>
  <h1 class="scalein animation-duration-500">Hello</h1>
</template>

<script>
  export default {
    name: 'AdminDashboard',
    props: {
      msg: String
    },
    created() {
      this.$emit("set-nav", this.$route)
    }
  }</script>